"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationBlockedError = void 0;
class ApplicationBlockedError extends Error {
    constructor() {
        super('Application was blocked by the browser');
    }
}
exports.ApplicationBlockedError = ApplicationBlockedError;
//# sourceMappingURL=ApplicationBlockedError.js.map